import { ReactNode, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { IntegrationsOutletContext } from "../types";

export const useLayoutActions = (actions: ReactNode) => {
  const { setLayoutActions } = useOutletContext<IntegrationsOutletContext>();

  useEffect(() => {
    if (!actions) {
      setLayoutActions(null);
    } else {
      setLayoutActions(actions);
    }

    return () => {
      setLayoutActions(null);
    };
  }, [actions, setLayoutActions]);
};
